<template>
	<DialogControl v-model="open" max-width="480">
		<v-card rounded="xl" class="nav-dialog">
			<v-card-title class="nav-dialog__title">
				<v-icon color="primary">support_agent</v-icon>
				<span>{{ t('Support') }}</span>
				<v-spacer />
				<v-btn icon variant="text" size="small" @click="open = false">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="nav-dialog__support">
				<v-btn v-for="action in SUPPORT_ACTIONS" :key="action.key" variant="tonal" block class="nav-dialog__support-action" @click="run(action)">{{ action.label }}</v-btn>
				<div class="nav-dialog__support-script">
					<v-text-field v-model="scriptId" variant="outlined" label="Script" />
					<v-btn color="primary" variant="flat" :disabled="!scriptId" @click="execute">5) Execute Support</v-btn>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn variant="text" @click="open = false">{{ t('Close') }}</v-btn>
			</v-card-actions>
		</v-card>
	</DialogControl>
</template>

<script setup>
import { ref } from 'vue';
import DialogControl from '@/components/controls/DialogControl.vue';
import { SUPPORT_ACTIONS, executeSupportScript, runSupportAction } from '@/iframe/legacyNavActions';
import { useTranslator } from '@/composables/useTranslator';

const open = defineModel({ type: Boolean, default: false });
const t = useTranslator();

const scriptId = ref('');

const run = (action) => {
	open.value = false;
	runSupportAction(action);
};

const execute = () => {
	executeSupportScript(scriptId.value.trim());
};
</script>
